'use client';

import { formatAppVersionBadge } from '@/lib/version-stamp';

/**
 * Tiny, unobtrusive version label. Reads the build-stamped
 * NEXT_PUBLIC_APP_VERSION (the same value GET /api/version returns and that's
 * baked into every image as an OCI label). Shows the clean SemVer for the
 * Kubernetes/AWS rail and a compact source identity for the single-server
 * rail; the full stamp remains in the tooltip.
 */
export function AppVersionBadge({ className = '' }: { className?: string }) {
  const full = process.env.NEXT_PUBLIC_APP_VERSION || 'dev';
  const label = formatAppVersionBadge(full);
  return (
    <span
      data-testid="app-version-badge"
      title={`${full} · GET /api/version`}
      className={`select-text font-mono text-[11px] leading-none text-white/40 ${className}`}
    >
      {label}
    </span>
  );
}
